class CartUpsellsList extends HTMLElement {
  constructor() {
      super();
      this.swiperEl = this;
      this.slidePrev = this.closest('.items__recommendations').querySelector('.items__recommendations-prev');
      this.slideNext = this.closest('.items__recommendations').querySelector('.items__recommendations-next');
  }

  initSwiper() {
      if (typeof Swiper !== 'undefined') {
          this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 2.2,
            spaceBetween: 12,
            navigation: {
              nextEl: this.slideNext,
              prevEl: this.slidePrev,
            }
          });
      }
  }

  connectedCallback() {
      this.initSwiper();
  }
}

if (!customElements.get('cart-upsells-list')) {
  customElements.define('cart-upsells-list', CartUpsellsList);
}